import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinjejuripune() {



  const cardData =
  {
    keyword: 'Bus On Rent in Jejuri Pune',
    heading: 'Sanavi Travels: Bus On Rent in Jejuri Pune',
    headingDescription: 'Bus On Rent in Jejuri Pune offers reliable and comfortable bus rental services for temple visits, weddings, family functions, corporate travel, school trips, picnics, and outstation journeys. With a wide range of AC and Non-AC buses from 20, 26, 32, 35, 40, 45 to 50 seaters, we ensure safe, spacious, and well-maintained vehicles for group travel. Backed by experienced chauffeurs, flexible rental packages, affordable pricing, and 24/7 booking support, bus rental services in Jejuri Pune are ideal for Jejuri temple darshan, Pune local trips, and long-distance tours, delivering a smooth, punctual, and hassle-free travel experience.',

    top: 'Top Places to Visit in Jejuri with Sanavi Travels',


"topPlaces": [
  {
    "title": "Jejuri Khandoba Temple",
    "description": "The Jejuri Khandoba Temple is one of Maharashtra’s most revered pilgrimage sites, dedicated to Lord Khandoba, an incarnation of Lord Shiva worshipped widely by farming and warrior communities. Perched atop a hill, the temple is reached by climbing nearly 200 stone steps, symbolizing devotion and perseverance. The temple complex includes the main sanctum, deepmalas, and smaller shrines, offering panoramic views of the surrounding countryside. Devotees believe that visiting Jejuri fulfills vows and brings prosperity, courage, and protection."
  },
  {
    "title": "Golden Turmeric Festival (Bhandara)",
    "description": "Jejuri is famously known as the ‘Golden City’ due to the spectacular turmeric festival celebrated during Somvati Amavasya and other auspicious days. During Bhandara, thousands of devotees shower turmeric powder over the temple, idols, and each other, turning the entire town golden. The vibrant celebration is filled with chants of devotion, traditional music, and deep spiritual fervor, making it one of the most visually stunning religious festivals in Maharashtra."
  },
  {
    "title": "Gadkot (Fortified Temple Complex)",
    "description": "The Gadkot area forms the fortified upper section of the Jejuri temple complex. It includes ancient stone walls, gateways, and watch points that highlight Jejuri’s historical importance. The fort-like structure reflects Maratha-era architecture and offers a sense of Jejuri’s strategic and religious significance in the past."
  },
  {
    "title": "Karha River",
    "description": "The Karha River flows near Jejuri and plays an important role in the town’s cultural and agricultural life. Pilgrims often perform ritual cleansing before visiting the temple, while the river supports local farming. During monsoon, the riverbanks turn lush green, adding natural beauty to the spiritual landscape."
  },
  {
    "title": "Jejuri Temple Steps and Deepmalas",
    "description": "The long flight of steps leading to the temple is lined with tall deepmalas (lamp towers) that are lit during festivals and special occasions. The climb itself is considered a spiritual journey, with devotees chanting ‘Yelkot Yelkot Jai Malhar’ as they ascend, creating a deeply immersive devotional atmosphere."
  },
  {
    "title": "Local Markets and Prasad Shops",
    "description": "The markets around Jejuri temple sell turmeric, coconuts, garlands, sweets, and religious offerings. Turmeric holds special importance as prasad of Lord Khandoba. These bustling lanes give visitors a taste of local devotion, culture, and traditional trade practices."
  },
  {
    "title": "Rural Maharashtrian Culture",
    "description": "Jejuri reflects authentic rural Maharashtrian life, deeply rooted in faith and tradition. Folk songs, devotional music, and community gatherings are common during festivals. The town offers visitors a close connection to village culture, customs, and heartfelt hospitality."
  },
  {
    "title": "Scenic Hilltop Views",
    "description": "From the top of the Jejuri hill, visitors can enjoy sweeping views of farmland, villages, and distant hills. Sunrise and sunset visits are especially mesmerizing, combining natural beauty with spiritual calm."
  },
  {
    "title": "Historical Significance of Khandoba Worship",
    "description": "The worship of Lord Khandoba in Jejuri dates back centuries and is closely associated with the Maratha period. Chhatrapati Shivaji Maharaj and many Maratha warriors were devoted to Khandoba, making Jejuri an important spiritual landmark in Maharashtra’s history."
  },
  {
    "title": "Pilgrimage and Weekend Destination",
    "description": "Located about 50 km from Pune, Jejuri is a popular one-day pilgrimage and weekend destination. Its blend of devotion, history, festivals, and scenic surroundings attracts pilgrims, photographers, and cultural enthusiasts throughout the year."
  }
]
,



"services": [
{
"name": "Bus On Rent in Jejuri Pune",
"description": "Bus On Rent in Jejuri Pune offers spacious, comfortable, and reliable buses for local and outstation travel. Perfect for families, groups, tourists, and religious pilgrims visiting Jejuri and surrounding areas, the service provides professional drivers, well-maintained vehicles, flexible scheduling, and a smooth, safe journey. Ideal for sightseeing trips, pilgrimages, corporate outings, and social events, it ensures convenience, comfort, and peace of mind for all travelers."
},
{
"name": "Bus Hire Jejuri",
"description": "Bus Hire Jejuri provides customizable bus rental services for family trips, corporate tours, group travel, and religious excursions. With modern buses, experienced drivers, and tailored itineraries, it ensures a safe, comfortable, and enjoyable travel experience. Passengers can enjoy hassle-free transportation to Jejuri and nearby destinations with punctual service and reliable vehicles."
},
{
"name": "AC Bus Jejuri",
"description": "AC Bus Jejuri offers fully air-conditioned buses for a comfortable and refreshing travel experience. Ideal for long-distance journeys, family trips, religious tours, and group excursions, these buses feature modern interiors, ample seating, and professional drivers, ensuring passengers enjoy a smooth, relaxing, and luxurious journey in Jejuri Pune and nearby areas."
},
{
"name": "Luxury Bus Jejuri",
"description": "Luxury Bus Jejuri provides premium buses with high-end amenities for weddings, corporate events, tourist trips, and religious tours. Equipped with spacious seating, entertainment systems, and professional drivers, these buses offer a safe, comfortable, and enjoyable travel experience for families, groups, and VIP travelers visiting Jejuri Pune."
},
{
"name": "Khandoba Darshan Bus",
"description": "Khandoba Darshan Bus specializes in transporting devotees to Khandoba temple in Jejuri. With organized itineraries, professional drivers, and well-maintained buses, it provides a safe, convenient, and stress-free pilgrimage experience. Perfect for families, groups of devotees, and tourists seeking a spiritual journey."
},
{
"name": "Religious Tour Bus Jejuri",
"description": "Religious Tour Bus Jejuri caters to pilgrims traveling to Jejuri and other nearby temples. Offering reliable transportation, comfortable seating, organized itineraries, and professional drivers, it ensures a seamless and spiritually fulfilling travel experience for devotees and religious tourists."
},
{
"name": "Family Bus Jejuri",
"description": "Family Bus Jejuri provides spacious and safe buses designed for family travel. With comfortable seating, professional drivers, and flexible travel options, it ensures enjoyable and hassle-free trips to Jejuri and surrounding areas for families of all sizes."
},
{
"name": "Affordable Bus Jejuri",
"description": "Affordable Bus Jejuri offers budget-friendly travel solutions without compromising on comfort or safety. Ideal for families, groups, corporate travelers, and solo tourists, it provides reliable buses with professional drivers, ensuring a safe and convenient journey to Jejuri and nearby destinations."
},
{
"name": "Chauffeur Driven Bus Jejuri",
"description": "Chauffeur Driven Bus Jejuri provides professional drivers who manage navigation, traffic, and schedules, allowing passengers to enjoy a stress-free journey. Suitable for family trips, religious tours, corporate outings, and group travel, it ensures smooth, safe, and comfortable transportation to Jejuri and surrounding regions."
},
{
"name": "Best Bus Service Jejuri",
"description": "Best Bus Service Jejuri guarantees high-quality buses, punctual service, and experienced drivers. Catering to families, corporate groups, tourists, and pilgrims, it provides reliable, safe, and comfortable transportation for religious tours, sightseeing, and outstation trips in Jejuri Pune."
},
{
"name": "Tourist Bus Jejuri",
"description": "Tourist Bus Jejuri caters to travelers exploring Jejuri and nearby attractions. With flexible itineraries, comfortable buses, and knowledgeable drivers, it provides a hassle-free and enjoyable sightseeing experience for families, groups, and solo tourists."
},
{
"name": "Group Travel Bus Jejuri",
"description": "Group Travel Bus Jejuri specializes in providing organized transportation for friends, corporate teams, devotees, and social groups. Spacious buses, professional drivers, and timely service ensure safe, smooth, and enjoyable group journeys to Jejuri Pune and surrounding areas."
},
{
"name": "Online Bus Booking Jejuri",
"description": "Online Bus Booking Jejuri allows passengers to reserve buses quickly and conveniently with instant confirmation. With multiple bus options, transparent pricing, and flexible schedules, it simplifies travel planning for families, tourists, corporate clients, and groups traveling to or from Jejuri."
},
{
"name": "Event Bus Jejuri",
"description": "Event Bus Jejuri provides buses for weddings, corporate events, parties, and other special occasions. Equipped with professional drivers, spacious seating, and reliable service, it ensures organized, comfortable, and safe transportation for all event attendees in and around Jejuri Pune."
},
{
"name": "Jejuri Travel Bus",
"description": "Jejuri Travel Bus offers complete travel solutions for sightseeing, religious tours, corporate trips, weddings, and outstation journeys. Combining comfort, safety, reliability, and professional service, it caters to families, tourists, and corporate clients seeking convenient and enjoyable bus travel in and around Jejuri Pune."
}
],
"tableData": [
["Bus On Rent in Jejuri Pune", "Bus Hire Jejuri"],
["AC Bus Jejuri", "Luxury Bus Jejuri"],
["Khandoba Darshan Bus", "Religious Tour Bus Jejuri"],
["Family Bus Jejuri", "Affordable Bus Jejuri"],
["Chauffeur Driven Bus Jejuri", "Best Bus Service Jejuri"],
["Tourist Bus Jejuri", "Group Travel Bus Jejuri"],
["Online Bus Booking Jejuri", "Event Bus Jejuri"],
["Jejuri Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Jejuri Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services in Jejuri Pune, ideal for group outings, family trips, pilgrimages, school tours, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Jejuri Pune and nearby destinations."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are well‑versed with Jejuri Pune routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Jejuri Pune, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Jejuri Pune."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Jejuri Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Jejuri Pune?',
    answer: 'Yes, Sanavi Travels offers dependable bus rental services in Jejuri Pune for various travel needs.'
  },
  {
    question: 'How can I book a bus in Jejuri Pune?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Jejuri Pune?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Jejuri Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Jejuri Pune routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Jejuri Pune?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Jejuri Pune and nearby areas.'
  },
  {
    question: 'Is the bus service in Jejuri Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Jejuri Pune to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Jejuri Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Patil',
    feedback: 'Booked a bus in Jejuri Pune with Sanavi Travels — very comfortable bus and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rekha Shinde',
    feedback: 'Sanavi Travels made our group trip in Jejuri Pune smooth and stress‑free. Highly recommended!',
    rating: 5
  }
];






























































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusOrCoach",
  "name": "Bus On Rent in Jejuri Pune - Sanavi Travels",
  "description": "Sanavi Travels provides bus rental services in Jejuri Pune. AC, luxury, family, Khandoba darshan, and religious tour buses available. Affordable, chauffeur-driven, and online booking enabled.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "26"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Bus On Rent in Jejuri Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC, luxury, family, Khandoba darshan, and religious tour buses in Jejuri Pune with Sanavi Travels. Affordable, chauffeur-driven, and online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/152.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinjejuripune;